import React from 'react';
import useMediaSelect from "app/app/mediaSelector/hooks/use-media-select";
import useMediaTranslation from "app/app/mediaSelector/hooks/use-translation";

function MediaItem({media}) {
    const trans = useMediaTranslation();
    const {selectedMedia, handleSelectMedia} = useMediaSelect();
    const {url, title, author, alt, sizes} = media;
    const selected = selectedMedia.includes(media);
    const photographer = author ? <p>{trans.media_grid.author + ': ' + author}</p> : '';

    const classNames = [
        'media-item',
        selected && 'media-item--selected',
    ].filter(Boolean).join(" ")

    return (
        <div className={classNames} onClick={() => handleSelectMedia(media)}>
            <div className={'media-item__image-container object-fit'}>
                <img src={sizes.medium_large} alt={alt}/>
            </div>

            {selected ?
                <span className={'media-item-select-badge media-item-select-badge--selected'}>
                    {trans.media_grid.chosen}
                </span>
                :
                <span className={'media-item-select-badge media-item-select-badge--select'}>
                    {trans.media_grid.choose_file}
                </span>
            }

            <div className={'media-item__inner'}>
                <div className={'media-item-info'}>
                    <div className={'text-container'}>
                        <h3>{title}</h3>
                        <p>{photographer}</p>
                    </div>
                    <a href={url} className={'button small transparent'} download>{trans.general.download}</a>
                </div>
            </div>
        </div>
    );
}

export default MediaItem;
